import { useLocation } from 'react-router-dom';

export const useIsActiveLink = (targetPath) => {
  const { pathname } = useLocation();
  return pathname === targetPath;
};
